(function(angular){
	'use strict';
	
	angular
		.module('featuredPropertyListingModule', [
			'popoverModule'
		]);

})(window.angular);